import { WebViewDetector } from '../services/webViewDetector/webViewDetector';

/**
 * Opens an app store link in a native overlay when possible
 * @param url The app store URL to open
 */
export const openAppStoreLink = (url: string) => {
  const deviceOS = WebViewDetector.getDeviceOS(navigator.userAgent);

  // For desktop, open the specific store that was clicked
  if (deviceOS === 'desktop') {
    window.open(url, '_blank');
    return;
  }

  // Create a temporary link element
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('target', '_blank');
  link.setAttribute('rel', 'noopener noreferrer');

  // For iOS, use itms-apps:// protocol
  if (deviceOS === 'ios') {
    link.href = url.replace('https://', 'itms-apps://');
  }

  // Trigger click programmatically
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
